module.exports = __webpack_public_path__ + "static/avatar_ani_lorak-507599f3d6e4b358992dc7cf848e851d.jpg";